import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../app/store";

export interface RequestCount {
  company: number | undefined;
  agents: number | undefined;
  companyRequests: number | undefined;
  propertyRequest: number | undefined;
  newNotificationCount: number | undefined;
}

const initialState: RequestCount = {
  company: 0,
  agents: 0,
  companyRequests: 0,
  propertyRequest: 0,
  newNotificationCount: 0,
};

export const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setRequestCount: (
      state,
      action: PayloadAction<
        Pick<
          RequestCount,
          "company" | "agents" | "companyRequests" | "propertyRequest"
        >
      >
    ) => {
      state.company = action.payload.company;
      state.agents = action.payload.agents;
      state.companyRequests = action.payload.companyRequests;
      state.propertyRequest = action.payload.propertyRequest;
    },
    setNotificationCount: (
      state,
      action: PayloadAction<Pick<RequestCount, "newNotificationCount">>
    ) => {
      state.newNotificationCount = action.payload.newNotificationCount;
    },
  },
});
export const { setRequestCount, setNotificationCount } = generalSlice.actions;
export const getCompanyCount = (state: RootState) => state.general.company;
export const getAgentCount = (state: RootState) => state.general.agents;
export const getCompanyRequestCount = (state: RootState) =>
  state.general.companyRequests;
export const getPropertyRequestCount = (state: RootState) =>
  state.general.propertyRequest;
export const getRecentNotificationCount = (state: RootState) =>
  state.general.newNotificationCount;
export default generalSlice.reducer;
